import { FC, ReactNode } from 'react';
import clsx from 'clsx';
import styles from './ProfileListSection.module.scss';

type Props = {
  title?: string;
  titleAction?: ReactNode;
  scrollClassName?: string;
  children: ReactNode;
  footer?: ReactNode;
};

const ProfileListSection: FC<Props> = ({
  title,
  titleAction,
  scrollClassName,
  children,
  footer,
}) => (
  <div className="tw-flex tw-flex-col tw-gap-2">
    {(title || titleAction) && (
      <div className="tw-flex tw-min-h-[32px] tw-items-center tw-justify-between tw-gap-2">
        <p className="tw-text-sm tw-font-medium tw-text-grayscale-100">
          {title}
        </p>
        {titleAction}
      </div>
    )}
    <div className="tw-flex tw-flex-col tw-gap-1">
      <div
        className={clsx(
          'tw-flex tw-flex-col tw-gap-2 tw-overflow-y-auto',
          styles.scrollContainer,
          scrollClassName,
        )}
      >
        {children}
      </div>
      {footer}
    </div>
  </div>
);

export default ProfileListSection;
